import { ReactDOM, ReactNode } from 'react'

export const highlightSubstring = (
  search: string | string[] | undefined,
  topic: string,
  Tag: keyof ReactDOM = 'mark',
  asString?: boolean,
): ReactNode => {
  if (!search || search.length === 0) {
    return topic
  }
  const searchArray = Array.isArray(search) ? search : [search]
  const pattern = new RegExp(`(${searchArray.join('|')})`, 'gi')
  const parts = topic.split(pattern)

  if (asString) {
    return parts.map(part => (pattern.test(part) ? `<${Tag}>${part}</${Tag}>` : part)).join('')
  }

  return (
    <span>
      {parts.map((part, i) =>
        pattern.test(part) ? <Tag key={i}>{part}</Tag> : <span>{part}</span>,
      )}
    </span>
  )
}
